var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 66.23 71.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-1, .cls-2 {\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 2px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u30D9\\u30FC\\u30B9",
    "data-name": "\\u30D9\\u30FC\\u30B9"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m11.03,42.39L46.73,1l18.5,15.81L30.16,58.51l-14.46,7.28s-9.51-.25-10.87-9.26l6.2-14.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m4.76,56.46l-3.44,9.99s-2.07,6.09,4.3,3.68l9.82-4.03s-9.25,2.93-10.68-9.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m10.38,43.88s3.57,16.05,18.78,14.71"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 49.9,
    y1: 8.03,
    x2: 16.77,
    y2: 47.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 56.57,
    y1: 14,
    x2: 23.27,
    y2: 53.96
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit_icon.22829ebf7aac13211075b4cc425716b5.svg";
export { ForwardRef as ReactComponent };